import $axios from "../../api/axios";

function getLstApi({ params, callback }) {
  $axios
    .get(`/api/user/favorites/0/9999999999/${params.page}/${params.pageSize}`)
    .then(res => {
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

export default {
  getLstApi
};



// WEBPACK FOOTER //
// ./src/api/account/book.js